module.exports = __webpack_public_path__ + "05_glasses_red.ebf51efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/05_glasses_red.png
// module id = szah
// module chunks = 0